import { InputCard } from '@components/cards';

import { EventChannelItemProps } from '../event-channel-view.type';

export const EventChannelItem = ({ name, isChecked, onSelect }: EventChannelItemProps) => (
  <InputCard isChecked={isChecked} isDisabled={false} handleClick={onSelect}>
    <p className='text-primary text-subtitle-m'>{name}</p>
  </InputCard>
);
